import { FaireDate } from "./FaireDate";
import { FaireDateRange } from "./FaireDateRange";

/**
 * {@link FaireDateRange} mutable counterpart.
 *
 * Allows undefined start and end dates to account for cases
 * when the user is entering date ranges. However, properly defined
 * data range should have a defined start range, see {@link toImmutableIfValid}.
 */
export class MutableFaireDateRange {
  /**
   * Construct date range.
   *
   * @param startDate Start range date.
   * @param endDate End range date. Same as start date or undefined is
   *     interpreted as a single date instead of an range.
   */
  constructor(
    public startDate: FaireDate | undefined,
    public endDate: FaireDate | undefined
  ) {}

  /** Convert to immutable if the range is valid. */
  toImmutableIfValid = (): FaireDateRange | undefined => {
    if (!!this.startDate && !!this.endDate) {
      return new FaireDateRange(this.startDate, this.endDate);
    }
    return;
  };
}
